


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ErrorCard extends Vue {
    /**
     * Error Image
     */
    @Prop({ default: require("@/assets/img/error.svg") })
    image: string;
}
